import React, { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, useNavigate } from 'react-router-dom';
import App from './App';
import useAppStore from './store';
import { initNetworkListener } from './utils/network';
import { supabase } from './lib/supabase';
import './index.css';

// Initialize network listener
initNetworkListener();

function Root() {
  const { loadInitialData, logout } = useAppStore();
  
  useEffect(() => {
    const initApp = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        if (session) {
          await loadInitialData();
        }
      } catch (error) {
        console.error('Failed to load initial data:', error);
        
        // Check if it's a refresh token error
        if (error instanceof Error && error.message.includes('Invalid Refresh Token')) {
          console.log('Invalid refresh token detected, clearing session');
          await logout();
          window.location.href = '/login';
        }
      }
    };
    
    initApp();
  }, [loadInitialData, logout]);
  
  return (
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );
}

createRoot(document.getElementById('root')!).render(<Root />);